export const preloader = () => {
    


    document.addEventListener("DOMContentLoaded", function() {

        let time = 6000; //6000

        if(document.querySelector("#animationCanvas")){
            time = 6000; //6000
        }

        // Проверяем, был ли прелоадер уже отображен
        if (localStorage.getItem("preloaderShown") !== "true") {
            // Показать прелоадер
            document.getElementById("preloader").style.display = "flex";
            document.getElementById("content").style.display = "none";
    
            // Скрыть прелоадер и показать контент после задержки в 5 секунд
            setTimeout(function() {
                document.getElementById("preloader").style.display = "none";
                document.getElementById("content").style.display = "block";
    
                // Сохранить информацию о том, что прелоадер был отображен
                localStorage.setItem("preloaderShown", "true");

            }, time);
        } else {

            time = 2000;
            document.getElementById("preloader").style.display = "flex";
            document.getElementById("content").style.display = "none";
    
            // Скрыть прелоадер и показать контент после задержки в 5 секунд
            setTimeout(function() {
                document.getElementById("preloader").style.display = "none";
                document.getElementById("content").style.display = "block";
    
                // Сохранить информацию о том, что прелоадер был отображен
                localStorage.setItem("preloaderShown", "true");

            }, time);
            // Прелоадер уже был отображен, показать сразу контент
           // document.getElementById("preloader").style.display = "none";
           // document.getElementById("content").style.display = "block";
        }
    });


     // Анимация переключения изображений в спиннере
    //  var spinnerImages = document.querySelectorAll(".spinner-image");
    //  var currentImage = 0;
 
    //  function showImage(index) {
    //      spinnerImages.forEach(function(image) {
    //          image.style.opacity = 0; // Скрыть все изображения
    //      });
    //      spinnerImages[index].style.opacity = 1; // Показать текущее изображение
    //  }
 
    //  function nextImage() {
    //      currentImage = (currentImage + 1) % spinnerImages.length; // Переключиться на следующее изображение
    //      showImage(currentImage);
    //  }
 
    //  // Показать первое изображение
    //  showImage(currentImage);
 
    //  // Переключать изображения каждую секунду
    //  setInterval(nextImage, 1000);
    



/*     document.addEventListener("DOMContentLoaded", function() {

        let time = 6300;
        setTimeout(function() {
            if( document.querySelector(".about-us__inner--hidden")){
                document.querySelector(".about-us__inner--hidden").classList.remove('about-us__inner--hidden');
            }
        }, time);
        
    }); */


    
    var userAgent = navigator.userAgent.toLowerCase(); 
    if (userAgent .indexOf('mac')!=-1){ 
        console.log( "macos header style" );
        //document.querySelector(".header__link_text").classList.add("header__link_text_macos");
        //document.querySelectorAll(".header__lang_text")[0].classList.add("header__lang_text_macos");
        document.querySelectorAll(".header__lang_svg")[0].classList.add("header__lang_svg_macos");
        document.querySelector(".quatro").classList.add("quatro_macos");
    }

    
}
